<div class="container">
    <div class="login-area">
        <h5>{{'validateKey.heading.title' | translate}}</h5>
        <h6>{{'validateKey.heading.supportingText' | translate}}</h6>

        <form [formGroup]="resetForm" (ngSubmit)="validate()" class="ui form">
            <div class="col-md-12 col-sm-12">
                <!-- <div class="form-group row">
                        <br />
                        <label for="pincode">Reset Key*</label>
                        <input #input formControlName="resetKey" type="text" class="form-control input-sm" placeholder=""
                            [autofocus]>
                        <div *ngIf="resetForm.controls['resetKey'].hasError('required') && resetForm.controls['resetKey'].touched"
                            class="alert alert-danger">You must provide a valid reset key.</div>
    
                    </div> -->
                <div class="form-group row">
                    <label for="pincode">{{'validateKey.fields.labels.newPassword' | translate}}</label>
                    <input formControlName="custPass" type="password" class="form-control input-sm" placeholder=""
                        required>
                    <div *ngIf="resetForm.controls['custPass'].hasError('required') && resetForm.controls['custPass'].touched"
                        class="alert alert-danger">{{'validateKey.fields.validation.errors.newPassword' | translate}}
                    </div>
                </div>
                <div class="form-group row">
                    <label for="pincode">{{'validateKey.fields.labels.confirmPassword' | translate}}</label>
                    <input formControlName="custPass2" type="password" class="form-control input-sm" placeholder="">
                    <div *ngIf="resetForm.controls['custPass2'].hasError('required') && resetForm.controls['custPass2'].touched"
                        class="alert alert-danger">{{'validateKey.fields.validation.errors.confirmPassword' |
                        translate}}</div>
                    <div class="alert alert-danger"
                        *ngIf="resetForm.controls['custPass2'].errors?.['MatchPassword'] === true && resetForm.controls['custPass2'].touched">
                        {{'validateKey.fields.validation.errors.noMatch' | translate}}</div>

                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <button [disabled]="!resetForm.valid" type="submit"
                            class='btn btn-primary btn-main btn-inlineblock'>{{'validateKey.buttons.submit' |
                            translate}}</button>
                    </div>
                </div>
            </div>
        </form>

    </div>

</div>